// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__8QYI1","accordionSummary":"styles_accordionSummary__WlNz8"};